const slugify = (string) => {
  let formattedString = string.toString().toLowerCase();
  formattedString = formattedString
    .replace(/[^a-z0-9\s]/gi, '')
    .replace(/\s+/g, '-');

  return formattedString;
};

export default slugify;
